import styled from "styled-components";

export const CommissionAreaChartWrapper = styled.div`
  
`;
